import { formatDate } from '@frontend/jetlend-core/src/formatters/formatUtils';
import Image from '@app/components/Image/Image';

import styles from './ScoringReject.module.scss';

export interface Props {
    /**
     * Дата следующего скоринга
     */
    nextScoringDate: string;
}

/**
 * Компонент для отображения отказа по результату скоринга
 */
export default function ScoringReject({
    nextScoringDate,
}: Props) {
    return (
        <div className={styles['content']}>
            <Image src="/next/assets/scoring-reject.png" alt="" width={68} height={68} />

            <h2 className={styles['title']} data-testid="limit-prescoring-modal__title">
                Мы не можем одобрить выдачу займа
            </h2>
            <div className={styles['text']}>
                Команда Jetlend благодарит вас за обращение и предоставленную информацию.
                <br />
                К сожалению, на сегодняшний день мы не можем одобрить выдачу займа вашей компании.
                <br />
                Желаем успехов в бизнесе!
            </div>
            <div className={styles['next-scoring-date']}>
                Мы будем рады повторному обращению после <span className={styles['next-scoring-date--colored']}>{formatDate(nextScoringDate)}</span>
            </div>
        </div>
    );
}